const locations = [
    {
        //dume
        name: "Malibu, CA",
        lat: 34.01577118061583,
        lng: -118.81435427306181,
        api_key: 'P1GNDFIMMHTOL883T16PQSYS8ILLRE5J',
        site_id: '2048560',
        sonnen_file: './Work_values-125661-12.11.2022-13.12.2022.csv'
    },
    {
        //nob hill
        name: "Ventura, CA",
        lat: 34.28969235222275,
        lng: -119.21097647305592,
        api_key: 'XVRME06UVZZ8Z4YSKDOLAWPN0QPEUF41',
        site_id: '3216399',
        sonnen_file: ''
    },
    {
        //skyview
        name: "Ventura, CA",
        lat: 34.291361652574444,
        lng: -119.21019384422038,
        api_key: 'TAIZZC11OHF8SR4RIA3KYLM1NZ4Y7U6T',
        site_id: '2140795',
        sonnen_file: './Work_values-126553-12.11.2022-13.12.2022.csv'
    },
    {
        //st andrews
        name: "Santa Rosa, CA",
        lat: 38.494104385313605,
        lng: -122.71399158645492,
        api_key: '',
        site_id: '',
        sonnen_file: './Work_values-132786-12.11.2022-13.12.2022.csv'
    },
    {
        //sedgemore
        name: "Santa Rosa, CA",
        lat: 38.48845617963577,
        lng: -122.69234770179735,
        api_key: '',
        site_id: '',
        sonnen_file: './Work_values-128470-12.11.2022-13.12.2022.csv'
    },
    {
        //burgess
        name: "Fraser, CO",
        lat: 39.98339854483314,
        lng: -105.80670449784348,
        api_key: 'KW0CIBOR7XLQX6CYFNJHHL5NMRHJYMN8',
        site_id: '1639176',
        sonnen_file: ''
    },
];

export default locations;